import classnames from 'classnames';
import { withFormsy } from 'formsy-react';
import React, { useMemo } from 'react';
import { createPrefixCls } from '../../_utils/string';
const prefixCls = createPrefixCls('form-validator');
const FormValidatorDecorator = ({ className, children, errorMessage, showRequired, isPristine, validationError, validationErrors, value, setValue }) => {
    const errMsg = useMemo(() => {
        return !isPristine
            ? showRequired
                ? validationError || (validationErrors && validationErrors.required) || '必填'
                : errorMessage
            : null;
    }, [errorMessage, isPristine, showRequired, validationError, validationErrors]);
    const cls = useMemo(() => {
        return classnames(prefixCls(), {
            [prefixCls('error')]: errMsg || (showRequired && !isPristine)
        }, className);
    }, [className, errMsg, isPristine, showRequired]);
    return (React.createElement("div", { className: cls },
        React.isValidElement(children) &&
            React.cloneElement(children, {
                setFormValue: setValue,
                formValue: value
            }),
        errMsg && React.createElement("p", { className: prefixCls('error-message') }, errMsg)));
};
export default withFormsy(FormValidatorDecorator);
